import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {FilterEvent} from '@models/pages/status-event-group-page/header-filter-event';

@Component({
    selector: 'scitis-status-event-group-page-actions',
    templateUrl: './status-event-group-page-actions.component.html',
    styleUrls: ['./status-event-group-page-actions.component.scss'],
    standalone: false
})
export class StatusEventGroupPageActionsComponent implements OnInit{

  @Output()
  private filter: EventEmitter<FilterEvent> = new EventEmitter<FilterEvent>();

  @Output()
  private update: EventEmitter<void> = new EventEmitter();

  public formGroup: UntypedFormGroup = new UntypedFormGroup({});

  constructor(
    private fb: UntypedFormBuilder
  ) {
  }

  ngOnInit(): void {
    this.initForm();
  }

  public onSubmit(): void {
    this.filter.emit(this.formGroup.value);
  }

  private initForm(): void {
    this.formGroup = this.fb.group({
      F: new UntypedFormControl(true),
      W: new UntypedFormControl(true),
      I: new UntypedFormControl(true),
      D: new UntypedFormControl(true),
      IH: new UntypedFormControl(true),
    });
  }

  public onUpdate() {
    this.update.emit();
  }
}
